import {
  getReadonlyListItemDate,
  getReadonlyListItemId,
  getReadonlyListItemPill,
  getReadonlyListItemString,
  getReadonlyListItemTranslatedString,
} from '@interxfi/app-components/components/readonly-list/util';
import { defaultValueStackedTypographyProps, type ReadonlyListItemRecord } from '@interxfi/design-system/components/list';
import type { IxcRaglV1ManualEntryData, IxcRaglV1ManualEntryState, IxcRaglV1ManualTransaction } from '@interxfi/types';
import { getJ5StateMetadataListItems } from '../../j5/state/j5-state-list-items';
import { getRaglReversedDetailListItems } from '../shared-ragl-list-items';
import { getRaglTransactionAssetListItems } from '../transaction/ragl-transaction-list-items';
import { getRaglTransactionDetailPath } from '../transaction/ragl-transaction-routing';
import { getRaglManualEntryPath } from './ragl-manual-entry-routing';
import { RaglManualEntryStatusPill } from './ragl-manual-entry-status-pill';

export function getRaglmanualEntryDataListItems(data: IxcRaglV1ManualEntryData | undefined, prefix = '') {
  return {
    transactionId: getReadonlyListItemId(
      `${prefix}transactionId`,
      'Transaction ID',
      data?.transactionId,
      getRaglTransactionDetailPath(data?.transactionId),
    ),
    effectiveAt: getReadonlyListItemDate(`${prefix}effectiveAt`, 'Effective At', data?.effectiveAt, 'timestamp_iso_s'),
    description: getReadonlyListItemString(`${prefix}description`, 'Description', data?.description),
    reversedDetails: data?.reversedDetails ? getRaglReversedDetailListItems(data.reversedDetails, `${prefix}reversedDetails.`) : undefined,
    assets: data?.assets?.map((asset, index) => getRaglTransactionAssetListItems(asset, `${prefix}assets.${index}.`)),
  } as const satisfies ReadonlyListItemRecord;
}

export function getRaglManualEntryStateListItems(data: IxcRaglV1ManualEntryState | undefined) {
  return {
    metadata: getJ5StateMetadataListItems(data?.metadata),
    entryId: getReadonlyListItemId('entryId', 'Entry ID', data?.entryId),
    status: getReadonlyListItemTranslatedString('status', 'Status', {
      namespace: 'ixcRaglV1',
      enumName: 'IxcRaglV1ManualEntryStatus',
      value: data?.status,
    }),
    statusPill: getReadonlyListItemPill('statusPill', 'Status', data?.status ? <RaglManualEntryStatusPill status={data.status} /> : null),
    data: getRaglmanualEntryDataListItems(data?.data, 'data.'),
  } as const satisfies ReadonlyListItemRecord;
}

export function getRaglManualTransactionListItems(data: IxcRaglV1ManualTransaction | undefined, prefix = '') {
  return {
    entryId: getReadonlyListItemId(
      `${prefix}entryId`,
      'Entry ID',
      data?.entryId,
      getRaglManualEntryPath({ kind: 'detail', keys: { entryId: data?.entryId } }),
    ),
    description: getReadonlyListItemString(
      `${prefix}description`,
      'Description',
      data?.description,
      undefined,
      data?.description ? { columns: 1, valueTypography: { ...defaultValueStackedTypographyProps, wrap: 'break-word' } } : undefined,
    ),
  } as const satisfies ReadonlyListItemRecord;
}
